import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=2fe1a530&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=2fe1a530&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1a530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe1a530')) {
      api.createRecord('2fe1a530', component.options)
    } else {
      api.reload('2fe1a530', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=2fe1a530&scoped=true", function () {
      api.rerender('2fe1a530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/components/Function.vue"
export default component.exports